export default __webpack_public_path__ + "956c92601aad31780e874b4fafc8636a.png";